// utils
// schema
import { format, startOfDay, subDays, subMonths } from "date-fns";

import { getColor } from "../../utils/getColor";

import { IEngagementFilterOption } from "./schema";

const formatToolTipDateRange = (date: Date) => {
	return `${format(date, "MMM d, y")} to ${format(new Date(), "MMM d, y")}`;
};

const Config = {
	ENGAGEMENT_RELEASE_DATE: new Date("2023, 7, 1"),
	BIN_SIZE: "month",
	FILTER_OPTIONS: [
		{
			label: "Overall",
			value: "all",
			tooltip: "All Dates",
		},
		{
			label: "30 Days",
			value: "30",
			tooltip: formatToolTipDateRange(startOfDay(subDays(new Date(), 30))),
		},
		{
			label: "90 Days",
			value: "90",
			tooltip: formatToolTipDateRange(startOfDay(subDays(new Date(), 90))),
		},
		{
			label: "12 Months",
			value: "year",
			tooltip: formatToolTipDateRange(startOfDay(subMonths(new Date(), 12))),
		},
	] as IEngagementFilterOption[],
	OVERVIEW: {
		ROW_HEIGHTS: [120, 0, 336, 336],
	},
	COHORTS: {
		ROW_HEIGHTS: [336, 32, 272],
	},
	QUESTIONS: {
		ROW_HEIGHTS: [120, 16, 456],
		TABLE: {
			DEFAULT_FACTOR_SELECTION: "All Factors",
			DEFAULT_COHORT_SELECTION: "all",
			DISTRIBUTION_COLUMN_WIDTH: 432,
		},
	},
	FACTORS: {
		// TODO: import from `packages/engagement/src/questions.json` when /assets become part of "workspaces"
		FACTORS: ["Role", "Management", "Leadership", "Fit", "Trust", "Organization", "Opportunity"],
		ROW_HEIGHTS: [336, 32, 368],
		HEATMAP: {
			DEFAULT_YEAR_SELECTION: new Date().getFullYear(),
			DEFAULT_COHORT_SELECTION: "all",
		},
	},
	eNPS: {
		ROW_HEIGHTS: [336, 32, 384],
	},
	ROUTES: {
		OVERVIEW: { label: "Overview", url: "/engagement/overview/" },
		COHORTS: { label: "Cohorts", url: "/engagement/cohorts/" },
		FACTORS: { label: "Factors", url: "/engagement/factors/" },
		QUESTIONS: { label: "Questions", url: "/engagement/questions/" },
		ENPS: { label: "eNPS", url: "/engagement/eNPS/" },
	},
};

// default function to determine heatmap color for a default cell
export const defaultSelectColor = (value: number | string) => {
	let numericValue: number;

	if (typeof value === "string") {
		numericValue = parseFloat(value);
		if (isNaN(numericValue)) {
			return getColor("primary", 1);
		}
	} else {
		numericValue = value;
	}

	if (numericValue >= 4.2) {
		return getColor("primary", 8);
	} else if (numericValue >= 3.4) {
		return getColor("primary", 7);
	} else if (numericValue >= 2.6) {
		return getColor("primary", 5);
	} else if (numericValue >= 1.8) {
		return getColor("primary", 3);
	} else {
		return getColor("primary", 1);
	}
};

export default Config;
